module.exports = __webpack_public_path__ + "img/roles_11.41cf52d8.png";